import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core'

@Component({
  selector: 'info-tooltip',
  templateUrl: 'info-tooltip.component.html',
  styleUrls: ['info-tooltip.component.scss'],
})
export class InfoTooltipComponent implements OnInit, OnChanges {
  @ViewChild('infoTooltip') btn: ElementRef
  @Input() label: string
  @Input() icon: string
  iconClassesDefault = 'fa fa-info-circle'
  iconClassesString = ''

  ngOnInit() {
    this.updateComponent()
  }

  ngOnChanges() {
    this.updateComponent()
    try {
      const jQuery = typeof window !== 'undefined' ? (window as any).$ || (window as any).jQuery : null
      if (jQuery && typeof jQuery === 'function') {
        jQuery(document).ready(function () {
          const el = jQuery('[data-toggle="tooltip"]')
          if (el && typeof el.tooltip === 'function') {
            el.tooltip()
          }
        })
      }
    } catch (e) {
      console.warn('Failed to initialize tooltip:', e)
    }
  }

  private updateComponent(): void {
    let iconClasses = ''
    if (this.icon && this.icon.length > 0) {
      iconClasses += this.icon.split('-')[0]
      iconClasses += ' ' + this.icon.replace('far-', 'fa-').replace('fas-', 'fa-')
    } else {
      iconClasses = this.iconClassesDefault
    }
    this.iconClassesString = iconClasses
  }
}
